import { FC } from "react";
import { ChooseOrganizationView } from "../../../../../../modules/preferences/views/choose-organization-vew/choose-organization-view";

export const ChooseOrganizationRoute: FC = () => {
    return (
        <ChooseOrganizationView />
    )
}